const { orderBy } = require('lodash');

const nations = {
  "CN": "China",
  "HK": "Hong Kong",
  "MY": "Malaysia",
  "SG": "Singapore",
  "ID": "Indonesia",
  "US": "United States",
  "AE": "United Arab Emirates",
  "AR": "Argentina",
  "AU": "Australia",
  "BE": "Belgium",
  "BR": "Brazil",
  "CA": "Canada",
  "CH": "Switzerland",
  "CL": "Chile",
  "CO": "Colombia",
  "CY": "Cyprus",
  "CZ": "Czech Republic",
  "DE": "Germany",
  "DK": "Denmark",
  "ES": "Spain",
  "FI": "Finland",
  "FR": "France",
  "GB": "United Kingdom",
  "GR": "Greece",
  "HR": "Croatia",
  "HU": "Hungary",
  "IE": "Ireland",
  "IN": "India",
  "IS": "Iceland",
  "IT": "Italy",
  "JP": "Japan",
  "LU": "Luxembourg",
  "MO": "Macao",
  "NL": "Netherlands",
  "NO": "Norway",
  "NZ": "New Zealand",
  "PH": "Philippines",
  "PL": "Poland",
  "PT": "Portugal",
  "RU": "Russian Federation",
  "SA": "Saudi Arabia",
  "SE": "Sweden",
  "SZ": "Swaziland",
  "TH": "Thailand",
  "VN": "Vietnam",
  "TR": "Turkey",
  "TW": "Taiwan",
  "ZA": "South Africa",
  "MT": "Malta",
  "KY": "Cayman",
  "BH": "Bahrain",
  "JM": "Jamaica",
}


module.exports.allNations = () => {
  const data = Object.keys(nations).map(e => {
    return {
      code: e.toLowerCase(),
      name: nations[e],
    }
  });

  return orderBy(data, 'name', 'asc')
}

module.exports.allNationsWithCaptial = () => {
  const data = Object.keys(nations).map(e => {
    return {
      code: e,
      name: nations[e],
    }
  });

  return orderBy(data, 'name', 'asc')
}